
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getVerifyReservationOtpDtoFormGroup() {
return new FormGroup({
    otp: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(6)]),
    accessKey: new FormControl<string | undefined>('', [Validators.required]),
    apiAppointmentSchedulerKey: new FormControl<string | undefined>(''),
})
;
}
      